<template>
    <div class="idle-flip-book">
        <!-- 路由 -->
        <div class="router-container">
            <router-link class="router-item" to="/read/readIndex">
                <span>首页</span>
            </router-link>/
            <router-link class="router-item" to="/read/themeBook">
                <span>主题书单</span>
            </router-link>/
            <div>
                <span>闲翻书</span>
            </div>
        </div>

        <div class="main-content">
            <div class="poll-grid">
                <div 
                    v-for="(poll, index) in pollItem.list" 
                    :key="index" 
                    class="poll-card"
                    
                >
                    <!-- 投票标题 -->
                    <div :class="poll.voteStatus ? 'poll-result' : 'poll-question'" @click="handlePollClick(poll)">
                        {{ poll.title }}
                    </div>
                    
                    <!-- 来源和参与人数 -->
                    <div class="poll-source-participants" @click="handlePollClick(poll)">
                        <div class="poll-source">{{ poll.source || '闲翻书·第20250720期' }}</div>
                        <div class="poll-participants">{{ poll.countA + poll.countB || '0' }}人参与</div>
                    </div>
                    
                    <!-- 投票选项 -->
                    <div v-if="!poll.voteStatus" class="poll-options">
                        <button class="option-btn blue-option" @click="vote(poll,'A')">
                            {{ poll.fieldA }}
                        </button>
                        <button class="option-btn red-option" @click="vote(poll,'B')">
                            {{ poll.fieldB }}
                        </button>
                    </div>
                    
                    <!-- 投票结果 -->
                    <div v-else class="poll-results" @click="handlePollClick(poll)">
                        <div class="result-item" v-for="(field, fieldIndex) in ['A', 'B']" :key="fieldIndex">
                            <div class="result-item-left">
                                <div class="result-label">{{ poll[`field${field}`] }}</div>
                                <div class="result-votes">{{ poll[`count${field}`] }}票</div>
                            </div>
                            <div class="result-item-right">
                                <div class="result-bar">
                                    <el-progress 
                                        :percentage="parseFloat((poll[`Ratio${field}`] || '0').replace('%', ''))" 
                                        :color="field === 'A' ? '#747FEB' : '#F4705E'"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <pagination
                :total="pollItem.total"
                :page-size="pollItem.pageSize"
                :current-page.sync="pollItem.pageIndex"
                @change="handlePageChange"
            />
        </div>
    </div>
</template>

<script>
import api from '@/api/index.js'
import pagination from './components/pagination.vue';
export default {
    name: 'idleFlipBook',
    components: {
        pagination
    },
    data() {
        return {
            pollItem:{
                pageIndex: 1,
                pageSize: 9,
                total: 0,
                list: [],

            }
        }
    },
    mounted() {
        this.getPollData();
    },
    methods: {
        async getPollData() {
            try {
                const res = await api.leisureList({
                    pageIndex: this.pollItem.pageIndex - 1,
                    pageSize: this.pollItem.pageSize,
                });
                if(res.data.status == 1){
                    this.pollItem.list = res.data.data
                    this.pollItem.total = res.data.total
                }
            }catch(error){
                this.$message.error(error.message);
            }
        },
         // 投票
        async vote(item, val) {
            const res = await api.fetchLeisureVote({ID: item.ID, field: val})
            if(res.status) {
                this.getPollData()
            }else{
                this.$message.error(res.message);
            }
            setTimeout(()=>{
                this.$router.push({
                    path: '/read/idleFlipBookDetails',
                    query: { ID: item.ID },
                });
            },500)
        },
        handlePollClick(poll) {
            this.$router.push({
                path: '/read/idleFlipBookDetails',
                query: { ID: poll.ID }
            });
        },
        handlePageChange(page,size) {
            this.pollItem.pageIndex = page;
            this.pollItem.pageSize = size;
            this.getPollData();
        }

    }
}
</script>

<style lang="scss" scoped>
.idle-flip-book {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0;
    background: #f7f7f7;
    position: relative;

    .router-container{
        display: flex;
        gap: 10px;
        margin: 16px 0;
        font-size: 12px;
        color: #666;
        .router-item{
            cursor: pointer;
            color: #666; 
        }
    }

    .main-content{

        .poll-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
            
            .poll-card {
                background: linear-gradient(180deg, #FDF3F3 0%, #fff 100%);
                border-radius: 12px;
                padding: 20px;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                transition: transform 0.2s ease;
                cursor: pointer;
                
                &:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
                }

                .poll-question {
                    font-size: 16px;
                    font-weight: 600;
                    color: #333;
                    margin-bottom: 8px;
                    line-height: 1.4;
                    height: 5.6em;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }

                .poll-result{
                    font-size: 14px;
                    font-weight: 600;
                    color: #333;
                    margin-bottom: 8px;
                    line-height: 1.4;
                    height: 2.8em;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }

                .poll-source-participants{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .poll-source {
                        font-size: 12px;
                        color: #666;
                        margin-bottom: 4px;
                    }

                    .poll-participants {
                        font-size: 12px;
                        color: #666;
                        margin-bottom: 16px;
                    }
                }

                .poll-options {
                    display: flex;
                    align-items: center;
                    gap: 8px;

                    .option-btn {
                        padding: 10px 16px;
                        border: none;
                        // border-radius: 6px;
                        font-size: 14px;
                        font-weight: 500;
                        cursor: pointer;
                        transition: all 0.2s ease;
                        flex: 1;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        padding: 14px 0;

                        &.blue-option {
                            background: #747FEB;
                            border-radius: 8px 0px 8px 8px;
                            color: #fff;

                            &:hover {
                                background: darken(#747FEB, 10%);
                            }
                        }

                        &.red-option {
                            background: #F4705E;
                            border-radius: 8px 8px 8px 0px;
                            color: #fff;

                            &:hover {
                                background: darken(#F4705E, 10%);
                            }
                        }
                    }
                }

                .poll-results {
                    margin-top: 10px;
                    .result-item {
                        margin-bottom: 12px;

                        .result-item-left{
                            display: flex;
                            align-items: center;
                            gap: 10px;

                            .result-label {
                                font-size: 12px;
                                color: #666;
                                margin-bottom: 4px;
                            }

                            .result-votes {
                                font-size: 12px;
                                color: #666;
                            }
                        }
                        
                    }
                }
            }
        }
    }
}

// 响应式设计
@media (max-width: 768px) {
    .idle-flip-book {
        .main-content {
            .poll-grid {
                grid-template-columns: repeat(2, 1fr);
                gap: 16px;
            }
        }
    }
}

@media (max-width: 480px) {
    .idle-flip-book {
        .main-content {
            .poll-grid {
                grid-template-columns: 1fr;
                gap: 12px;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.idle-flip-book {
    .el-progress{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>
